import { Reducer } from 'redux';
import { Action, ActionType } from '../../actions';
import { DistributionChannelV2EditorData } from '../../state/DistributionChannelsV2/EditorData';

const getDistributionChannelV2EditorData: Reducer<DistributionChannelV2EditorData> = (
  state: DistributionChannelV2EditorData = new DistributionChannelV2EditorData(),
  action: Action<ActionType, DistributionChannelV2EditorData>
) => {
  switch (action.type) {
    case ActionType.DISTRIBUTION_CHANNELS_V2_EDITOR_DATA_FETCHED:
      return { ...state, distributionChannels: action.data };
    default:
      return state;
  }
};

export default getDistributionChannelV2EditorData;
